(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cadife-contact"]) return;
  try {
    
  (function() {
    var lang = localStorage.getItem('cadife-lang') || 'tr';
    function applyLang(l) {
      document.querySelectorAll('[data-tr][data-en]').forEach(function(el) {
        var t = el.getAttribute('data-' + l);
        if (t) { if (el.tagName === 'INPUT') el.placeholder = t; else el.textContent = t; }
      });
    }
    applyLang(lang);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cadife-featured-styles"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var wrap = document.getElementById('cfs-{{ section.id }}');
    if (!wrap) return;

    var tabs   = wrap.querySelectorAll('.cfs__tab');
    var panels = {
      jut:         wrap.querySelector('#cfs-panel-jut'),
      yikanabilir: wrap.querySelector('#cfs-panel-yikanabilir'),
      koridor:     wrap.querySelector('#cfs-panel-koridor')
    };

    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        var key = this.dataset.tab;
        tabs.forEach(function(t) {
          t.classList.remove('cfs__tab--active');
          t.setAttribute('aria-selected', 'false');
        });
        Object.values(panels).forEach(function(p) {
          if (p) p.classList.add('cfs__panel--hidden');
        });
        this.classList.add('cfs__tab--active');
        this.setAttribute('aria-selected', 'true');
        if (panels[key]) panels[key].classList.remove('cfs__panel--hidden');
      });
    });

    /* Arrow scroll — only the Jüt panel has a real carousel */
    var carousel = wrap.querySelector('.cfs__carousel');
    if (!carousel) return;
    wrap.querySelector('.cfs__arrow--prev').addEventListener('click', function() {
      var card = carousel.querySelector('.cfs__card');
      var step = card ? (card.offsetWidth + 20) * 2 : 420;
      carousel.scrollBy({ left: -step, behavior: 'smooth' });
    });
    wrap.querySelector('.cfs__arrow--next').addEventListener('click', function() {
      var card = carousel.querySelector('.cfs__card');
      var step = card ? (card.offsetWidth + 20) * 2 : 420;
      carousel.scrollBy({ left: step, behavior: 'smooth' });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cadife-header"]) return;
  try {
    
  /* Scroll nav */
  var scrolledNav = document.getElementById('cadife-nav-scrolled');
  window.addEventListener('scroll', function() {
    if (window.scrollY > 100) { scrolledNav.classList.add('visible'); }
    else { scrolledNav.classList.remove('visible'); }
  });

  /* Search */
  ['search-toggle-scrolled', 'search-toggle-static'].forEach(function(id) {
    var el = document.getElementById(id);
    if (el) el.addEventListener('click', function() { document.getElementById('cadife-search-panel').classList.add('active'); });
  });
  document.getElementById('search-close').addEventListener('click', function() { document.getElementById('cadife-search-panel').classList.remove('active'); });

  /* Mobile */
  document.getElementById('mobile-toggle').addEventListener('click', function() { document.getElementById('cadife-mobile').classList.add('active'); });
  document.getElementById('mobile-close').addEventListener('click', function() { document.getElementById('cadife-mobile').classList.remove('active'); });

  /* Mega Menu */
  (function() {
    var overlay = document.getElementById('cadife-mega-overlay');
    var allPanels = document.querySelectorAll('.cadife-mega');

    function closeAll() {
      allPanels.forEach(function(p) { p.classList.remove('open'); });
      overlay.classList.remove('active');
    }

    function openPanel(id) {
      allPanels.forEach(function(p) { p.classList.remove('open'); });
      var panel = document.getElementById(id);
      if (panel) panel.classList.add('open');
      overlay.classList.add('active');
    }

    [document.getElementById('cadife-nav-scrolled'), document.getElementById('cadife-nav-static')].forEach(function(nav) {
      if (!nav) return;

      nav.querySelectorAll('.cadife-mega-trigger').forEach(function(trigger) {
        trigger.addEventListener('mouseenter', function() {
          openPanel(this.dataset.mega);
        });
        trigger.addEventListener('click', function() {
          if (!window.matchMedia('(hover: none)').matches) return;
          var panelId = this.dataset.mega;
          var panel = document.getElementById(panelId);
          if (panel && panel.classList.contains('open')) { closeAll(); }
          else { openPanel(panelId); }
        });
      });

      nav.addEventListener('mouseleave', function() {
        closeAll();
      });
    });

    overlay.addEventListener('click', closeAll);
  })();

  /* Language toggle handlers are in theme.liquid global script */

  /* Cart drawer trigger */
  document.querySelectorAll('.cadife-cart-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var drawer = document.querySelector('cart-drawer-component');
      if (drawer && typeof drawer.open === 'function') {
        drawer.open();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cadife-pdp-nav"]) return;
  try {
    
  (function() {
    var nav = document.getElementById('cadife-pdp-nav');
    if (!nav) return;
    var overlay = document.getElementById('cadife-pdp-nav-overlay');
    var staticHeader = document.getElementById('cadife-nav-static');
    var wrapper = nav.closest('.cadife-pdp-nav-wrapper');

    var portalDrop = null;
    var portalPlaceholder = null;

    function updateTop() {
      var top;
      if (window.scrollY > 100) {
        top = 50;
      } else {
        top = staticHeader ? Math.round(staticHeader.getBoundingClientRect().height) : 80;
      }
      nav.style.top = top + 'px';
      if (wrapper) {
        var headerSection = staticHeader ? staticHeader.closest('.shopify-section') : null;
        var headerFlowH = headerSection ? headerSection.offsetHeight : 0;
        wrapper.style.height = Math.max(36, top + 36 - headerFlowH) + 'px';
      }
      if (portalDrop) {
        portalDrop.style.top = Math.round(nav.getBoundingClientRect().bottom) + 'px';
      }
    }

    updateTop();
    window.addEventListener('scroll', updateTop, { passive: true });
    window.addEventListener('resize', updateTop);

    function restorePortal() {
      if (portalDrop && portalPlaceholder) {
        portalDrop.classList.remove('cadife-pdp-nav__drop--mobile-open');
        portalDrop.style.top = '';
        portalPlaceholder.parentNode.insertBefore(portalDrop, portalPlaceholder);
        portalPlaceholder.remove();
      }
      portalDrop = null;
      portalPlaceholder = null;
    }

    function closeAll() {
      nav.querySelectorAll('.cadife-pdp-nav__item.open').forEach(function(el) {
        el.classList.remove('open');
      });
      restorePortal();
      if (overlay) overlay.classList.remove('active');
    }

    nav.querySelectorAll('.cadife-pdp-nav__item--has-drop').forEach(function(item) {
      var trigger = item.querySelector('.cadife-pdp-nav__trigger');
      if (!trigger) return;
      trigger.addEventListener('click', function(e) {
        if (window.innerWidth > 768) return;
        e.stopPropagation();
        var isOpen = item.classList.contains('open');
        closeAll();
        if (!isOpen) {
          item.classList.add('open');
          var drop = item.querySelector('.cadife-pdp-nav__drop');
          if (drop) {
            portalPlaceholder = document.createComment('cadife-pdp-nav-drop-placeholder');
            drop.parentNode.insertBefore(portalPlaceholder, drop);
            document.body.appendChild(drop);
            drop.classList.add('cadife-pdp-nav__drop--mobile-open');
            drop.style.top = Math.round(nav.getBoundingClientRect().bottom) + 'px';
            portalDrop = drop;
          }
          if (overlay) overlay.classList.add('active');
        }
      });
    });

    if (overlay) overlay.addEventListener('click', closeAll);
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') closeAll();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cadife-shop"]) return;
  try {
    
  (function() {
    var lang = localStorage.getItem('cadife-lang') || 'tr';
    function applyLang(l) {
      document.querySelectorAll('[data-tr][data-en]').forEach(function(el) {
        var t = el.getAttribute('data-' + l);
        if (t) { if (el.tagName === 'INPUT') el.placeholder = t; else el.textContent = t; }
      });
    }
    applyLang(lang);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
